import React, { useEffect } from "react"
import { Divider, Flex, message, Table } from "antd"
import useColumns from "../hooks/useColumns"
import { useActions } from "../../../hooks/useActions"
import { useTypedSelector } from "../../../hooks/useTypedSelector"
import ReverseChanges from "./ReverseChanges"
import { ApplyOnAmazonStatus } from "../../../types/history"

const ManyTargetCampaignsHistory: React.FC = () => {
  const { history, error, loading } = useTypedSelector((state) => state.history)
  const { dateRange, countryCode } = useTypedSelector((select) => select.filter)

  const { fetchHistory } = useActions()

  useEffect(() => {
    fetchHistory(dateRange)
  }, [dateRange, countryCode])

  useEffect(() => {
    if (error) {
      message.error(error)
    }
  }, [error])

  const columns = useColumns()

  const reversibleRowIds = history
    .filter((target) => target.status === ApplyOnAmazonStatus.COMPLETED)
    .map((target) => target._id)

  return (
    <>
      <Flex justify="flex-end">
        <ReverseChanges selectedRowId={reversibleRowIds} history={history} />
      </Flex>

      <Divider />

      <Table
        rowKey="_id"
        columns={columns}
        dataSource={history}
        showSorterTooltip={{ target: "sorter-icon" }}
        scroll={{ x: "max-content" }}
        loading={loading}
      />
    </>
  )
}

export default ManyTargetCampaignsHistory
